<template>
    <b-dropdown-item
        class="user-dropdown-item"
        data-cy="userDropdownItem"
        :href="href"
        :rel="rel"
        :target="target"
        :to="to"
        @click="$emit('click', $event)"
    >
        <FontAwesomeIcon
            v-if="icon && variant === 'default'"
            class="icon"
            :icon="icon"
            data-cy="userDropdownItemIcon"
        />

        <!-- Content/text to be displayed in the dropdown item -->
        <slot />
    </b-dropdown-item>
</template>

<script>
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
    import {props} from 'bootstrap-vue/src/components/dropdown/dropdown-item';

    /**
     * @group Layout
     * A component to display a dropdown item within the `UserDropdown`
     * component.
     * <br>
     * __Note__: In addition to the props below, [all props from the `b-dropdown-item`
     * component may also be used](https://bootstrap-vue.org/docs/components/dropdown#comp-ref-b-dropdown-item-props).
     */
    export default {
        name: 'UserDropdownItem',
        components: {
            FontAwesomeIcon,
        },
        inject: ['variant'],
        props: {
            ...props,
            /**
             * Denotes a custom icon to be displayed using `FontAwesomeIcon`; only
             * displayed if the injected variant is `default`
             */
            icon: {
                type: [String, Array],
                required: false,
                // `undefined`
                default: undefined,
            },
        },
    };
</script>
